// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__RhVZP","icon":"style_icon__2YXy6","title":"style_title__36u2S","logo":"style_logo__3YBPZ","logoContainer":"style_logoContainer__3wq0-"};